import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

import _ from "lodash";
import moment from "moment-timezone";

import { DormitoryTab } from "components/pages/dormitories-page";
import { Container, Row } from "components/ui-kit/styled-templates";
import Table from "components/ui-kit/table";

import EventsApi from "api/events-api";
import UniversityApi from "api/university-api";

import useBodyBackground from "hooks/useBodyBackground";
import useQueryParams from "hooks/useQueryParams";
import { useStorageListener } from "hooks/useStorage";
import { EVENT_TYPES_OPTIONS } from "constants/config";
import { ERoles } from "../../../types/enums";

const EventsListPage = () => {
    const { t } = useTranslation();

    const { params } = useQueryParams();
    const { universityId } = params;
    const navigate = useNavigate();
    useBodyBackground("white");

    const university = useStorageListener(`universities`, {});
    const role: ERoles = useStorageListener(`user.userRole`, ERoles.Guest);
    console.log('render: role = ', role);
    let events = useStorageListener(`events`, []);

    const selectedUniversity = _.get(university, universityId);

    let rows = _.values(events)?.filter?.((i) => (!!universityId ? i?.universityId === universityId : true));

    if (role == ERoles.ClubsAdmin) {
        rows = rows.filter(x => (x?.details?.clubId != undefined))
    }

    useEffect(() => {
        UniversityApi.getAllUniversitiesData();
        EventsApi.getEvents();
    }, []);

    const rowsToShow = rows.map((i) => ({ ...i, university: _.get(university, i.universityId) }));

    return (
        <Container extra="padding-top: 10px; align-items: flex-start;">
            <Row extra="gap: 15px;">
                {universityId && (
                    <DormitoryTab.Link color="blue" direction="left" onClick={() => navigate(-1)}>
                        {t("036p26d5q6hk")}
                    </DormitoryTab.Link>
                )}
                <h2>{t("bm38g0o5fzq")}</h2>
            </Row>
            {universityId && (
                <Row extra="gap: 10px;">
                    <strong>{t("8lad6jnl7up")}</strong>
                    <p>{_.get(selectedUniversity, `details.name`)}</p>
                </Row>
            )}
            <Table
                name="admin-events-dashboard"
                withPagination={false}
                useBackendProcessing={false}
                paginationPerPage={2000}
                rows={rowsToShow}
                sortable={true}
                columns={[
                    { name: `number`, label: `№`, extra: `width: 50px; flex: unset;`, showIndexOnClick: true },
                    { name: `details.name`, label: `Название` },
                    {
                        name: `details.dates.from`,
                        label: `Начало`,
                        transform: ({ row }) => moment(row?.details?.dates?.from).format("DD.MM.YYYY"),
                    },
                    { name: `details.dates.to`, label: `Конец`, transform: ({ row }) => moment(row?.details?.dates?.to).format("DD.MM.YYYY") },
                    { name: `details.price`, label: `Стоимость` },
                    {
                        name: `details.type`,
                        label: `Тип`,
                        transform: ({ row }) => EVENT_TYPES_OPTIONS.find((i) => i.value === row?.details?.type)?.label,
                    },
                    { name: `university.details.shortName`, label: `Университет` },
                    { name: `university.details.region`, label: `Регион` },
                    {
                        name: `hideFromAll`,
                        label: ``,
                        transform: ({ row }) => (row?.hideFromAll ? 'y-y' : '-'),
                        cell: {
                            type: "icon",
                            className: "w-6 h-6 cursor-pointer",
                            srcFunction:  (({ row }) => (row?.hideFromAll ? 'eye-x' : ''))
                        }
                    },
                    {
                        name: `onModeration`,
                        label: `Ожидает модерации`,
                        transform: ({ row }) => (row?.onModeration ? t("igs9x5cjcfr") : t("iv9r5j6zkco")),
                    },
                    // {
                    //     name: `university.details.name`,
                    //     label: `Университет`,
                    //     extra: `flex: 4;`,
                    //     onCellClick: ({ row }) => navigate(`/university/${row.universityId}`),
                    // },
                    // { name: `details.main-info.name`, label: `Название`, extra: `flex: 4;` },
                    // { name: `university.details.region`, label: `Субъект`, extra: `flex: 1.5;` },
                    // { name: `details.main-info.city`, label: `Город` },
                    // {
                    //     name: `onModeration`,
                    //     label: `Ожидает модерации`,
                    //     transform: ({ row }) => (row?.onModeration ? t("igs9x5cjcfr") : t("iv9r5j6zkco")),
                    // },
                    // {
                    //     name: `progressLength`,
                    //     label: `Прогресс`,
                    //     extra: `width: 100px; flex: unset; justify-content: center;`,
                    // },
                    // {
                    //     name: `progress`,
                    //     label: ``,
                    //     extra: `width: 80px; flex: unset;`,
                    //     cell: { type: `dormitoryComplitnessStatus` },
                    //     sortable: false,
                    // },
                    {
                        name: `menu`,
                        label: ``,
                        sortable: false,
                        extra: `flex: unset; width: 24px;`,
                        cell: {
                            type: `menu`,
                            options: [
                                { label: `Просмотр`, onClick: ({ row, navigate }) => navigate(`/events/${row.id}`) },
                                {
                                    label: `Модерация пройдена`,
                                    onClick: ({ row, navigate }) =>
                                        EventsApi.updateEvent({ id: row.id, universityId: row.universityId, onModeration: false }),
                                },
                                {
                                    label: `Вернуть на модерацию`,
                                    onClick: ({ row, navigate }) => {
                                        let comment = window.prompt(`Введите комментарий для модерации`);
                                        EventsApi.updateEvent({ id: row.id, universityId: row.universityId, onModeration: true, moderationComment: comment })
                                    },
                                },
                            ],
                        },
                    },
                ]}
            />
        </Container>
    );
};

export default EventsListPage;
